import {Toast, Notify, Dialog} from 'vant'

// 设置提示延迟
Toast.setDefaultOptions({duration: 3000});
Toast.setDefaultOptions('loading', {forbidClick: true});

Notify.setDefaultOptions({duration: 4500});

class UILoader {
  constructor() {
    this.loader = null;
  }

  load(info = '加载中...') {
    this.unload();
    this.loader = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: info,
    });
  }

  setInfo(info) {
    if (info && this.loader) {
      this.loader.message = info;
    }
  }

  unload() {
    this.loader = null;
    Toast.clear();
  }
}

// 轻提示，用于 query
window.vtToast = Toast;
// 重要提示，用于 mutation
window.vtNotify = Notify;
window.vtDialog = Dialog;
window.UILoader = new UILoader();
